import content from "./content.json";

export const { SITE_URL, SERVICE_PAGES, PUBLIC_PAGES } = content;
export const HOME_SEO = PUBLIC_PAGES["/"];

// Landing pages can accept enquiries; bookings require current catalog services.
// Availability, brands, service scope and prices come from CatalogContext.
export const servicePageForCategory = (id) => SERVICE_PAGES.find(page => page.categoryId === id);

export const hasCatalogServices = (category) => Boolean(category?.services?.length);
